import * as React from "react";

export interface Props {
  imageSrc?: string;
  onCloseRequest: () => void;
  isSlide?: boolean;
  imageArray?: string[];
  firstImageIndex?: number;
}

interface State {
  imageIndex: number;
  images: string[];
}

// Lightweight lightbox replacement (react-images is not compatible with React 19)
export default class EnlargeImage extends React.Component<Props, State> {
  static defaultProps = {
    isSlide: false,
    imageSrc: "",
    imageArray: [],
    firstImageIndex: 0,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      imageIndex: props.firstImageIndex || 0,
      images: props.imageArray || [],
    };
  }

  componentDidUpdate(prevProps: Props) {
    if (
      prevProps.imageArray !== this.props.imageArray ||
      prevProps.firstImageIndex !== this.props.firstImageIndex
    ) {
      this.setState({
        images: this.props.imageArray || [],
        imageIndex: this.props.firstImageIndex || 0,
      });
    }
  }

  handlePrev = () => {
    const { images, imageIndex } = this.state;
    if (!images.length) return;
    this.setState({
      imageIndex: (imageIndex + images.length - 1) % images.length,
    });
  };

  handleNext = () => {
    const { images, imageIndex } = this.state;
    if (!images.length) return;
    this.setState({
      imageIndex: (imageIndex + 1) % images.length,
    });
  };

  render() {
    const { imageSrc, onCloseRequest, isSlide } = this.props;
    const { images, imageIndex } = this.state;

    const currentSrc = isSlide
      ? images[imageIndex] || images[0]
      : imageSrc || "";

    if (!currentSrc) {
      return null;
    }

    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.85)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
        role="dialog"
        aria-modal="true"
      >
        <button
          onClick={onCloseRequest}
          style={{
            position: "absolute",
            top: 16,
            right: 16,
            background: "rgba(0,0,0,0.6)",
            color: "#fff",
            border: "none",
            padding: "8px 12px",
            cursor: "pointer",
            fontSize: 16,
          }}
          aria-label="Close"
        >
          ×
        </button>

        {isSlide && images.length > 1 && (
          <button
            onClick={this.handlePrev}
            style={{
              position: "absolute",
              left: 16,
              background: "rgba(0,0,0,0.6)",
              color: "#fff",
              border: "none",
              padding: "12px",
              cursor: "pointer",
              fontSize: 18,
            }}
            aria-label="Previous image"
          >
            ‹
          </button>
        )}

        <img
          src={currentSrc}
          alt=""
          style={{
            maxHeight: "90vh",
            maxWidth: "90vw",
            objectFit: "contain",
            boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
          }}
        />

        {isSlide && images.length > 1 && (
          <button
            onClick={this.handleNext}
            style={{
              position: "absolute",
              right: 16,
              background: "rgba(0,0,0,0.6)",
              color: "#fff",
              border: "none",
              padding: "12px",
              cursor: "pointer",
              fontSize: 18,
            }}
            aria-label="Next image"
          >
            ›
          </button>
        )}
      </div>
    );
  }
}
